/* eslint no-underscore-dangle: ["error", { "allow":
["__EXCEPTIONTRACE__", "__STATETRACE_LAST_5__"] }] */
import { sendbug } from '../../../app/util/net';
import StackTrace from 'stacktrace-js';
import { stackToString } from './promiserejection.interceptor.js';
window.__EXCEPTIONTRACE__ = window.__EXCEPTIONTRACE__ ? window.__EXCEPTIONTRACE__ : [];

function pushStack(message, filename, lineno, colno, error, stack) {
  window.__EXCEPTIONTRACE__.push(
    {
      message,
      filename,
      lineno,
      colno,
      lastStates: '',
      error: {
        message: error ? error.message : '',
        stack,
      },
    }
  );
  sendbug();
}

window.onerror = function onerror(message, filename, lineno, colno, error) {
  if (error && error.stack) {
    StackTrace.fromError(error)
      .then(mappedStack => pushStack(message, filename, lineno, colno, error,
        stackToString(mappedStack)),
      () => pushStack(message, filename, lineno, colno, error, ''))
      .catch(() => pushStack(message, filename, lineno, colno, error, ''));
  } else {
    pushStack(message, filename, lineno, colno, error, '');
  }
};
